function choose_area_index() {
  return import(
    /* webpackChunkName: "page-choose-area-index" */ '@/pages/choose-area/index.vue'
  )
}
function classify_index() {
  return import(
    /* webpackChunkName: "page-classify-index" */ '@/pages/classify/index.vue'
  )
}
function debug_index() {
  return import(
    /* webpackChunkName: "page-debug-index" */ '@/pages/debug/index.vue'
  )
}
function find_index() {
  return import(
    /* webpackChunkName: "page-find-index" */ '@/pages/find/index.vue'
  )
}
function home_index() {
  return import(
    /* webpackChunkName: "page-home-index" */ '@/pages/home/index.vue'
  )
}
function landing_index() {
  return import(
    /* webpackChunkName: "page-landing-index" */ '@/pages/landing/index.vue'
  )
}
function nearby_index() {
  return import(
    /* webpackChunkName: "page-nearby-index" */ '@/pages/nearby/index.vue'
  )
}
function notice_index() {
  return import(
    /* webpackChunkName: "page-notice-index" */ '@/pages/notice/index.vue'
  )
}
function noticeDesc_index() {
  return import(
    /* webpackChunkName: "page-noticeDesc-index" */ '@/pages/noticeDesc/index.vue'
  )
}
function productContent_index() {
  return import(
    /* webpackChunkName: "page-productContent-index" */ '@/pages/productContent/index.vue'
  )
}
function recharge_index() {
  return import(
    /* webpackChunkName: "page-recharge-index" */ '@/pages/recharge/index.vue'
  )
}
function search_index() {
  return import(
    /* webpackChunkName: "page-search-index" */ '@/pages/search/index.vue'
  )
}
function search_result_index() {
  return import(
    /* webpackChunkName: "page-search-result-index" */ '@/pages/search-result/index.vue'
  )
}
function user_index() {
  return import(
    /* webpackChunkName: "page-user-index" */ '@/pages/user/index.vue'
  )
}
function workCupBanner_index() {
  return import(
    /* webpackChunkName: "page-workCupBanner-index" */ '@/pages/workCupBanner/index.vue'
  )
}
function account_login() {
  return import(
    /* webpackChunkName: "page-account-login" */ '@/pages/account/login.vue'
  )
}
function debug_schema() {
  return import(
    /* webpackChunkName: "page-debug-schema" */ '@/pages/debug/schema.vue'
  )
}
function find_luckyDraw_index() {
  return import(
    /* webpackChunkName: "page-find-luckyDraw-index" */ '@/pages/find/luckyDraw/index.vue'
  )
}
function find_shareEarn_index() {
  return import(
    /* webpackChunkName: "page-find-shareEarn-index" */ '@/pages/find/shareEarn/index.vue'
  )
}
function order_evaluate() {
  return import(
    /* webpackChunkName: "page-order-evaluate" */ '@/pages/order/evaluate.vue'
  )
}
function order_evaluateSuccess() {
  return import(
    /* webpackChunkName: "page-order-evaluateSuccess" */ '@/pages/order/evaluateSuccess.vue'
  )
}
function order_booking_index() {
  return import(
    /* webpackChunkName: "page-order-booking-index" */ '@/pages/order/booking/index.vue'
  )
}
function order_list_index() {
  return import(
    /* webpackChunkName: "page-order-list-index" */ '@/pages/order/list/index.vue'
  )
}
function order_reserve_index() {
  return import(
    /* webpackChunkName: "page-order-reserve-index" */ '@/pages/order/reserve/index.vue'
  )
}
function order_submit_index() {
  return import(
    /* webpackChunkName: "page-order-submit-index" */ '@/pages/order/submit/index.vue'
  )
}
function recharge_indexV1() {
  return import(
    /* webpackChunkName: "page-recharge-indexV1" */ '@/pages/recharge/indexV1.vue'
  )
}
function recharge_detail_index() {
  return import(
    /* webpackChunkName: "page-recharge-detail-index" */ '@/pages/recharge/detail/index.vue'
  )
}
function recharge_record_index() {
  return import(
    /* webpackChunkName: "page-recharge-record-index" */ '@/pages/recharge/record/index.vue'
  )
}
function recharge_result_index() {
  return import(
    /* webpackChunkName: "page-recharge-result-index" */ '@/pages/recharge/result/index.vue'
  )
}
function system_about() {
  return import(
    /* webpackChunkName: "page-system-about" */ '@/pages/system/about.vue'
  )
}
function system_platform() {
  return import(
    /* webpackChunkName: "page-system-platform" */ '@/pages/system/platform.vue'
  )
}
function system_service() {
  return import(
    /* webpackChunkName: "page-system-service" */ '@/pages/system/service.vue'
  )
}
function system_setting() {
  return import(
    /* webpackChunkName: "page-system-setting" */ '@/pages/system/setting.vue'
  )
}
function user_cooperation() {
  return import(
    /* webpackChunkName: "page-user-cooperation" */ '@/pages/user/cooperation.vue'
  )
}
function user_order() {
  return import(
    /* webpackChunkName: "page-user-order" */ '@/pages/user/order.vue'
  )
}
function user_reserve_index() {
  return import(
    /* webpackChunkName: "page-user-reserve-index" */ '@/pages/user/reserve/index.vue'
  )
}
function user_reserve_detail_index() {
  return import(
    /* webpackChunkName: "page-user-reserve-detail-index" */ '@/pages/user/reserve-detail/index.vue'
  )
}
function product_webview_index() {
  return import(
    /* webpackChunkName: "page-product-webview-index" */ '@/pages/product/webview/index.vue'
  )
}
function shop_detail_index() {
  return import(
    /* webpackChunkName: "page-shop-detail-index" */ '@/pages/shop/detail/index.vue'
  )
}
function shop_qualification_index() {
  return import(
    /* webpackChunkName: "page-shop-qualification-index" */ '@/pages/shop/qualification/index.vue'
  )
}
function shop_shareCopy_index() {
  return import(
    /* webpackChunkName: "page-shop-shareCopy-index" */ '@/pages/shop/shareCopy/index.vue'
  )
}
function shop_store_index() {
  return import(
    /* webpackChunkName: "page-shop-store-index" */ '@/pages/shop/store/index.vue'
  )
}
function shop_storeInfo_index() {
  return import(
    /* webpackChunkName: "page-shop-storeInfo-index" */ '@/pages/shop/storeInfo/index.vue'
  )
}
function account_callback_wx() {
  return import(
    /* webpackChunkName: "page-account-callback-wx" */ '@/pages/account/callback/wx.vue'
  )
}
function find_luckyDraw_detail_old() {
  return import(
    /* webpackChunkName: "page-find-luckyDraw-detail-old" */ '@/pages/find/luckyDraw/detail-old.vue'
  )
}
function find_luckyDraw_marketList() {
  return import(
    /* webpackChunkName: "page-find-luckyDraw-marketList" */ '@/pages/find/luckyDraw/marketList.vue'
  )
}
function find_luckyDraw_record() {
  return import(
    /* webpackChunkName: "page-find-luckyDraw-record" */ '@/pages/find/luckyDraw/record.vue'
  )
}
function find_luckyDraw_storeList() {
  return import(
    /* webpackChunkName: "page-find-luckyDraw-storeList" */ '@/pages/find/luckyDraw/storeList.vue'
  )
}
function find_luckyDraw_detail_index() {
  return import(
    /* webpackChunkName: "page-find-luckyDraw-detail-index" */ '@/pages/find/luckyDraw/detail/index.vue'
  )
}
function find_shareEarn_search() {
  return import(
    /* webpackChunkName: "page-find-shareEarn-search" */ '@/pages/find/shareEarn/search.vue'
  )
}
function order_booking_cancel() {
  return import(
    /* webpackChunkName: "page-order-booking-cancel" */ '@/pages/order/booking/cancel.vue'
  )
}
function order_booking_detail() {
  return import(
    /* webpackChunkName: "page-order-booking-detail" */ '@/pages/order/booking/detail.vue'
  )
}
function order_booking_record() {
  return import(
    /* webpackChunkName: "page-order-booking-record" */ '@/pages/order/booking/record.vue'
  )
}
function order_booking_search() {
  return import(
    /* webpackChunkName: "page-order-booking-search" */ '@/pages/order/booking/search.vue'
  )
}
function shop_component_product() {
  return import(
    /* webpackChunkName: "page-shop-component-product" */ '@/pages/shop/component/product.vue'
  )
}
function find_luckyDraw__com_item() {
  return import(
    /* webpackChunkName: "page-find-luckyDraw-com-item" */ '@/pages/find/luckyDraw/_com/item.vue'
  )
}
function find_luckyDraw__com_recordItem() {
  return import(
    /* webpackChunkName: "page-find-luckyDraw-com-recordItem" */ '@/pages/find/luckyDraw/_com/recordItem.vue'
  )
}
function find_luckyDraw__com_store() {
  return import(
    /* webpackChunkName: "page-find-luckyDraw-com-store" */ '@/pages/find/luckyDraw/_com/store.vue'
  )
}
function find_shareEarn__com_item() {
  return import(
    /* webpackChunkName: "page-find-shareEarn-com-item" */ '@/pages/find/shareEarn/_com/item.vue'
  )
}
function order_list__com__item() {
  return import(
    /* webpackChunkName: "page-order-list-com_-item" */ '@/pages/order/list/_com_/item.vue'
  )
}
function nearby__com_item() {
  return import(
    /* webpackChunkName: "page-nearby-com-item" */ '@/pages/nearby/_com/item.vue'
  )
}
function order__id_pay_result_new() {
  return import(
    /* webpackChunkName: "page-order-id-pay-result-new" */ '@/pages/order/_id/pay-result-new.vue'
  )
}
function order__id_pay_result() {
  return import(
    /* webpackChunkName: "page-order-id-pay-result" */ '@/pages/order/_id/pay-result.vue'
  )
}
function order__id_check_code_index() {
  return import(
    /* webpackChunkName: "page-order-id-check-code-index" */ '@/pages/order/_id/check-code/index.vue'
  )
}
function order__id_check_code_gift_index() {
  return import(
    /* webpackChunkName: "page-order-id-check-code-gift-index" */ '@/pages/order/_id/check-code-gift/index.vue'
  )
}
function order__id_detail_index() {
  return import(
    /* webpackChunkName: "page-order-id-detail-index" */ '@/pages/order/_id/detail/index.vue'
  )
}
function order__id_giftdetail_index() {
  return import(
    /* webpackChunkName: "page-order-id-giftdetail-index" */ '@/pages/order/_id/giftdetail/index.vue'
  )
}
function order__id_refund_index() {
  return import(
    /* webpackChunkName: "page-order-id-refund-index" */ '@/pages/order/_id/refund/index.vue'
  )
}
function order__id_self_check_index() {
  return import(
    /* webpackChunkName: "page-order-id-self-check-index" */ '@/pages/order/_id/self-check/index.vue'
  )
}
function product__id_comment_index() {
  return import(
    /* webpackChunkName: "page-product-id-comment-index" */ '@/pages/product/_id/comment/index.vue'
  )
}
function product__id_detail_index() {
  return import(
    /* webpackChunkName: "page-product-id-detail-index" */ '@/pages/product/_id/detail/index.vue'
  )
}
function product__id_storeList_index() {
  return import(
    /* webpackChunkName: "page-product-id-storeList-index" */ '@/pages/product/_id/storeList/index.vue'
  )
}
function order__id_check_code__com__code() {
  return import(
    /* webpackChunkName: "page-order-id-check-code-com_-code" */ '@/pages/order/_id/check-code/_com_/code.vue'
  )
}

export default [
  {
    name: 'choose-area',
    path: 'choose-area',
    component: choose_area_index,
  },
  {
    name: 'classify',
    path: 'classify',
    component: classify_index,
  },
  {
    name: 'debug',
    path: 'debug',
    component: debug_index,
  },
  {
    name: 'find',
    path: 'find',
    component: find_index,
    meta: {
      title: '发现页',
      isShowTabBar: true,
      hideTopbar: true,
    },
  },
  {
    name: 'home',
    path: 'home',
    component: home_index,
    meta: {
      isShowTabBar: true,
      hideTopbar: true,
      keepAlive: true,
    },
  },
  {
    name: 'landing',
    path: 'landing',
    component: landing_index,
    meta: {
      isShowTabBar: false,
      hideTopbar: true,
    },
  },
  {
    name: 'nearby',
    path: 'nearby',
    component: nearby_index,
    meta: {
      isShowTabBar: true,
      hideTopbar: true,
    },
  },
  {
    name: 'notice',
    path: 'notice',
    component: notice_index,
  },
  {
    name: 'noticeDesc',
    path: 'noticeDesc',
    component: noticeDesc_index,
  },
  {
    name: 'productContent',
    path: 'productContent',
    component: productContent_index,
  },
  {
    name: 'recharge',
    path: 'recharge',
    component: recharge_index,
  },
  {
    name: 'search',
    path: 'search',
    component: search_index,
  },
  {
    name: 'search-result',
    path: 'search-result',
    component: search_result_index,
  },
  {
    name: 'user',
    path: 'user',
    component: user_index,
    meta: {
      isShowTabBar: true,
      hideTopbar: true,
    },
  },
  {
    name: 'workCupBanner',
    path: 'workCupBanner',
    component: workCupBanner_index,
  },
  {
    name: 'account-login',
    path: 'account/login',
    component: account_login,
  },
  {
    name: 'debug-schema',
    path: 'debug/schema',
    component: debug_schema,
  },
  {
    name: 'find-luckyDraw',
    path: 'find/luckyDraw',
    component: find_luckyDraw_index,
  },
  {
    name: 'find-shareEarn',
    path: 'find/shareEarn',
    component: find_shareEarn_index,
  },
  {
    name: 'order-evaluate',
    path: 'order/evaluate',
    component: order_evaluate,
  },
  {
    name: 'order-evaluateSuccess',
    path: 'order/evaluateSuccess',
    component: order_evaluateSuccess,
  },
  {
    name: 'order-booking',
    path: 'order/booking',
    component: order_booking_index,
  },
  {
    name: 'order-list',
    path: 'order/list',
    component: order_list_index,
  },
  {
    name: 'order-reserve',
    path: 'order/reserve',
    component: order_reserve_index,
  },
  {
    name: 'order-submit',
    path: 'order/submit',
    component: order_submit_index,
  },
  {
    name: 'recharge-indexV1',
    path: 'recharge/indexV1',
    component: recharge_indexV1,
  },
  {
    name: 'recharge-detail',
    path: 'recharge/detail',
    component: recharge_detail_index,
  },
  {
    name: 'recharge-record',
    path: 'recharge/record',
    component: recharge_record_index,
  },
  {
    name: 'recharge-result',
    path: 'recharge/result',
    component: recharge_result_index,
  },
  {
    name: 'system-about',
    path: 'system/about',
    component: system_about,
  },
  {
    name: 'system-platform',
    path: 'system/platform',
    component: system_platform,
  },
  {
    name: 'system-service',
    path: 'system/service',
    component: system_service,
  },
  {
    name: 'system-setting',
    path: 'system/setting',
    component: system_setting,
  },
  {
    name: 'user-cooperation',
    path: 'user/cooperation',
    component: user_cooperation,
  },
  {
    name: 'user-order',
    path: 'user/order',
    component: user_order,
  },
  {
    name: 'user-reserve',
    path: 'user/reserve',
    component: user_reserve_index,
  },
  {
    name: 'user-reserve-detail',
    path: 'user/reserve-detail',
    component: user_reserve_detail_index,
  },
  {
    name: 'product-webview',
    path: 'product/webview',
    component: product_webview_index,
  },
  {
    name: 'shop-detail',
    path: 'shop/detail',
    component: shop_detail_index,
  },
  {
    name: 'shop-qualification',
    path: 'shop/qualification',
    component: shop_qualification_index,
  },
  {
    name: 'shop-shareCopy',
    path: 'shop/shareCopy',
    component: shop_shareCopy_index,
  },
  {
    name: 'shop-store',
    path: 'shop/store',
    component: shop_store_index,
  },
  {
    name: 'shop-storeInfo',
    path: 'shop/storeInfo',
    component: shop_storeInfo_index,
  },
  {
    name: 'account-callback-wx',
    path: 'account/callback/wx',
    component: account_callback_wx,
  },
  {
    name: 'find-luckyDraw-detail-old',
    path: 'find/luckyDraw/detail-old',
    component: find_luckyDraw_detail_old,
  },
  {
    name: 'find-luckyDraw-marketList',
    path: 'find/luckyDraw/marketList',
    component: find_luckyDraw_marketList,
  },
  {
    name: 'find-luckyDraw-record',
    path: 'find/luckyDraw/record',
    component: find_luckyDraw_record,
  },
  {
    name: 'find-luckyDraw-storeList',
    path: 'find/luckyDraw/storeList',
    component: find_luckyDraw_storeList,
  },
  {
    name: 'find-luckyDraw-detail',
    path: 'find/luckyDraw/detail',
    component: find_luckyDraw_detail_index,
  },
  {
    name: 'find-shareEarn-search',
    path: 'find/shareEarn/search',
    component: find_shareEarn_search,
  },
  {
    name: 'order-booking-cancel',
    path: 'order/booking/cancel',
    component: order_booking_cancel,
  },
  {
    name: 'order-booking-detail',
    path: 'order/booking/detail',
    component: order_booking_detail,
  },
  {
    name: 'order-booking-record',
    path: 'order/booking/record',
    component: order_booking_record,
  },
  {
    name: 'order-booking-search',
    path: 'order/booking/search',
    component: order_booking_search,
  },
  {
    name: 'shop-component-product',
    path: 'shop/component/product',
    component: shop_component_product,
  },
  {
    name: 'find-luckyDraw-com-item',
    path: 'find/luckyDraw/:com/item',
    component: find_luckyDraw__com_item,
  },
  {
    name: 'find-luckyDraw-com-recordItem',
    path: 'find/luckyDraw/:com/recordItem',
    component: find_luckyDraw__com_recordItem,
  },
  {
    name: 'find-luckyDraw-com-store',
    path: 'find/luckyDraw/:com/store',
    component: find_luckyDraw__com_store,
  },
  {
    name: 'find-shareEarn-com-item',
    path: 'find/shareEarn/:com/item',
    component: find_shareEarn__com_item,
  },
  {
    name: 'order-list-com_-item',
    path: 'order/list/:com_/item',
    component: order_list__com__item,
  },
  {
    name: 'nearby-com-item',
    path: 'nearby/:com/item',
    component: nearby__com_item,
  },
  {
    name: 'order-id-pay-result-new',
    path: 'order/:id/pay-result-new',
    component: order__id_pay_result_new,
  },
  {
    name: 'order-id-pay-result',
    path: 'order/:id/pay-result',
    component: order__id_pay_result,
  },
  {
    name: 'order-id-check-code',
    path: 'order/:id/check-code',
    component: order__id_check_code_index,
  },
  {
    name: 'order-id-check-code-gift',
    path: 'order/:id/check-code-gift',
    component: order__id_check_code_gift_index,
  },
  {
    name: 'order-id-detail',
    path: 'order/:id/detail',
    component: order__id_detail_index,
  },
  {
    name: 'order-id-giftdetail',
    path: 'order/:id/giftdetail',
    component: order__id_giftdetail_index,
  },
  {
    name: 'order-id-refund',
    path: 'order/:id/refund',
    component: order__id_refund_index,
  },
  {
    name: 'order-id-self-check',
    path: 'order/:id/self-check',
    component: order__id_self_check_index,
  },
  {
    name: 'product-id-comment',
    path: 'product/:id/comment',
    component: product__id_comment_index,
  },
  {
    name: 'product-id-detail',
    path: 'product/:id/detail',
    component: product__id_detail_index,
  },
  {
    name: 'product-id-storeList',
    path: 'product/:id/storeList',
    component: product__id_storeList_index,
  },
  {
    name: 'order-id-check-code-com_-code',
    path: 'order/:id/check-code/:com_/code',
    component: order__id_check_code__com__code,
  },
]
